import { render } from "./ProductsList.vue?vue&type=template&id=ba72e1fa&ts=true"
import script from "./ProductsList.vue?vue&type=script&lang=ts"
export * from "./ProductsList.vue?vue&type=script&lang=ts"

import "./ProductsList.vue?vue&type=style&index=0&id=ba72e1fa&lang=css"

import exportComponent from "C:\\Users\\Muhammad Sohail\\Herd\\yellowrockshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__